module.exports = __webpack_public_path__ + "static/elephant-5-7d3d83a1345e8ba51856a7e40fc298a6.gif";